import { render } from "./ActiveDetail.vue?vue&type=template&id=dff4abf8&scoped=true"
import script from "./ActiveDetail.vue?vue&type=script&lang=js"
export * from "./ActiveDetail.vue?vue&type=script&lang=js"

import "./ActiveDetail.vue?vue&type=style&index=0&id=dff4abf8&lang=less&scoped=true"

import exportComponent from "G:\\website\\work\\xmjh\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff4abf8"]])

export default __exports__